
import React from "react";
import { Search, SlidersHorizontal } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { cn } from "@/lib/utils";
import { Collapsible, CollapsibleContent } from "@/components/ui/collapsible";
import MultiStatusFilter from "../MultiStatusFilter";
import ActiveFiltersDisplay from "../ActiveFiltersDisplay";

interface MobileNotificationFiltersProps {
  searchTerm: string;
  setSearchTerm: (value: string) => void;
  unreadFilter: boolean;
  toggleUnreadFilter: () => void;
  selectedStatuses: string[];
  setSelectedStatuses: (statuses: string[]) => void;
  unreadCount: number;
  showFilters: boolean;
  setShowFilters: (value: boolean) => void;
}

const MobileNotificationFilters = ({
  searchTerm,
  setSearchTerm,
  unreadFilter,
  toggleUnreadFilter,
  selectedStatuses,
  setSelectedStatuses,
  unreadCount,
  showFilters,
  setShowFilters
}: MobileNotificationFiltersProps) => {
  return (
    <>
      <div className="flex gap-2 sticky top-14 z-10 bg-background pt-1 pb-2">
        <div className="relative flex-grow">
          <Search className="absolute left-2.5 top-2.5 h-4 w-4 text-muted-foreground" />
          <Input
            type="search"
            placeholder="Zoek in meldingen..."
            className="pl-8 h-10 rounded-full bg-gray-50 border-gray-200"
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
          />
        </div>
        <Button 
          variant="outline" 
          size="icon"
          onClick={() => setShowFilters(!showFilters)}
          className={cn(
            "rounded-full w-10 h-10 bg-gray-50 border-gray-200", 
            showFilters && "bg-accent text-accent-foreground"
          )}
        >
          <SlidersHorizontal className="h-4 w-4" />
        </Button>
      </div>
      
      <Collapsible open={showFilters} onOpenChange={setShowFilters}>
        <CollapsibleContent className="space-y-2 pb-4 animate-accordion-down">
          <div className="p-3 bg-gray-50 rounded-lg border border-gray-100">
            <div className="space-y-3">
              <div className="flex items-center justify-between">
                <div className="flex items-center">
                  <Button
                    variant={unreadFilter ? "default" : "outline"}
                    size="sm"
                    onClick={toggleUnreadFilter}
                    className="text-xs h-8"
                  >
                    Alleen ongelezen ({unreadCount})
                  </Button>
                </div>
              </div>
              
              <div>
                <MultiStatusFilter
                  selectedStatuses={selectedStatuses}
                  onStatusChange={setSelectedStatuses}
                  className="w-full"
                />
              </div>

              <ActiveFiltersDisplay
                selectedStatuses={selectedStatuses}
                onRemoveStatus={(status) => setSelectedStatuses(selectedStatuses.filter(s => s !== status))}
                onClearAll={() => setSelectedStatuses([])}
              />
            </div>
          </div>
        </CollapsibleContent>
      </Collapsible>
    </>
  );
};

export default MobileNotificationFilters;
